import React, { useEffect, useState } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import BalanceTransactionTableFilter from "../Filters/BalanceTransactionTableFilter";
import {
  Table,
  Empty,
  Col,
  Row,
  notification,
  message,
  Button,
  Modal,
} from "antd";
import {
  OrderedListOutlined,
  CopyOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import CurrencyFormat from "react-currency-format";
import { useMediaQuery } from "react-responsive";
import { ColumnHelper } from "util/TableHelper";

const BalanceTransactionList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "İŞLEMLERİM" });
  const [balanceTransactions, setBalanceTransactions] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 20,
    current: 1,
    filter: "",
  });
  const [balance, setBalance] = useState("");
  const [currencyCode, setCurrencyCode] = useState(" TRY");
  const [currentPage, setCurrentPage] = useState(1);
  const [balanceLoadingModalVisible, setBalanceLoadingModalVisible] =
    useState(false);
  const [copyIban, setCopyIban] = useState("TR123150075223123");
  const [copyAlici, setCopyAlici] = useState(
    "POLYNOM TEKNOLOJİ BİLGİSAYAR YAZILIMLARI BİLİŞİM DANIŞMANLIK VE SANAYİ ANONİM ŞİRKETİ"
  );
  const [copyPaymentCode, setCopyPaymentCode] = useState("");

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  const columns = [
    {
      title: "İşlem",
      dataIndex: "balanceProcessType",
      key: "balanceProcessType",
      align: "left",
    },
    {
      title: "Tarih",
      dataIndex: "addDate",
      key: "addDate",
      align: "left",
      render: (data) => {
        return moment(data).format("l");
      },
    },
    {
      title: "İşlem Tipi",
      dataIndex: "transactionProcessType",
      key: "transactionProcessType",
      align: "left",
    },
    {
      title: "Gelen",
      dataIndex: "collectString",
      key: "collectString",
      align: "left",
    },

    {
      title: "Giden",
      dataIndex: "paymentString",
      key: "paymentString",
      align: "left",
    },

    {
      title: "Bakiye",
      dataIndex: "balanceTotalString",
      key: "balanceTotalString",
      align: "left",
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setBalanceTransactions(e);
  };

  useEffect(() => {
    RequestHandler.post(`/BalanceHistory/CheckBalance`, {}, false).then(
      (response) => {
        setBalance(response.balanceString);
      }
    );

    RequestHandler.get(`/BalanceHistory/GetInvoicePaymentCode`).then(
      (response) => {
        setCopyPaymentCode(response);
      }
    );
  }, []);

  useEffect(() => {
    const { skip, take, filter } = tableDataQueryOptions;

    const order = "&$orderby=addDate desc";
    let query = "";
    if (filter) {
      query = "$filter=" + filter;
    }
    RequestHandler.get(
      `/BalanceHistory?${query}${order} &$count=true&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setBalanceTransactions({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  }, [tableDataQueryOptions]);

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        {isDesktopOrLaptop ? (
          <Col xs={24} md={6} lg={4} style={{ textAlign: "end" }}>
            <Button
              type="primary"
              icon={<QuestionCircleOutlined />}
              onClick={() => {
                setBalanceLoadingModalVisible(true);
              }}
            >
              Bakiye Yükle
            </Button>
          </Col>
        ) : (
          <Col xs={24} md={6} lg={4}>
            <Button
              type="primary"
              icon={<QuestionCircleOutlined />}
              onClick={() => {
                setBalanceLoadingModalVisible(true);
              }}
            >
              Bakiye Yükle
            </Button>
          </Col>
        )}
        <Col xs={24} md={6} lg={4} style={{ fontSize: 20, marginTop: "5px" }}>
          Bakiye : {balance}
        </Col>
      </Row>
      <BalanceTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={balanceTransactions.data}
            loading={balanceTransactions.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: balanceTransactions.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: currentPage,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
      <Modal
        visible={balanceLoadingModalVisible}
        centered={true}
        keyboard={true}
        title={<p style={{ fontWeight: "400" }}>Bakiye Yükleme Yönlendirme</p>}
        width={767}
        onOk={() => {
          setBalanceLoadingModalVisible(false);
        }}
        onCancel={() => {
          setBalanceLoadingModalVisible(false);
        }}
        footer={[
          <Button
            type="primary"
            onClick={() => setBalanceLoadingModalVisible(false)}
          >
            Tamam
          </Button>,
        ]}
      >
        <>
          <Col xs={24} md={12} lg={24}>
            <p>
              Havale/EFT işlemi sonrası yatırdığınız tutar otamatik olarak
              bakiyenize aktarılacaktır.
            </p>
            <p style={{ fontWeight: 650 }}>ALICI</p>
            <p>
              POLYNOM TEKNOLOJİ BİLGİSAYAR YAZILIMLARI BİLİŞİM DANIŞMANLIK VE
              SANAYİ ANONİM ŞİRKETİ{" "}
              <Button
                icon={<CopyOutlined />}
                style={{ fontSize: "130%", marginLeft: "20px" }}
                onClick={() =>
                  navigator.clipboard
                    .writeText(copyAlici)
                    .then(() => message.success("Alıcı ismi Kopyalandı."))
                }
              ></Button>
            </p>
            <p style={{ fontWeight: 650 }}>IBAN</p>
            <p>
              {copyIban}{" "}
              <Button
                icon={<CopyOutlined />}
                style={{ fontSize: "130%", marginLeft: "20px" }}
                onClick={() =>
                  navigator.clipboard
                    .writeText(copyIban)
                    .then(() => message.success("Iban Kopyalandı."))
                }
              ></Button>
            </p>
            <p style={{ fontWeight: 650 }}>AÇIKLAMA</p>
            <p>
              *Açıklama alanına ödeme kodunun eklenmemesi halinde bakiye
              yüklenemez.
            </p>
            <p>
              {copyPaymentCode}
              <Button
                icon={<CopyOutlined />}
                style={{ fontSize: "130%", marginLeft: "20px" }}
                onClick={() =>
                  navigator.clipboard
                    .writeText(copyPaymentCode)
                    .then(() => message.success("Ödeme Kodu Kopyalandı."))
                }
              ></Button>
            </p>
          </Col>
        </>
      </Modal>
    </>
  );
};

export default BalanceTransactionList;
